// usePermission.ts
// import { el } from '@fullcalendar/core/internal-common';
import { usePermissions } from './../context/PermissionsContext';

interface Page {
  page_code: string;
  allowed_privileges?: string[];
}

interface Module {
  module_code: string;
  pages: Page[];
}
 interface CommonModule {
  module_code: string;
  path: string;
}
export const MenuPermission =  (nav:any[], commonModuleCode: CommonModule) =>{
  const { permissions } =  usePermissions();
  
  const result:any[]=[];
  let index;
    nav.forEach((ele) => {
      if (Array.isArray(permissions)) {
        index =  permissions?.findIndex(x => x.module_code === ele.module_code);
        
        // Hardcode service_master for testing
        if (ele.module_code === 'service_parameters') {
          index = 0; // Force it to be found
        }
        
        if(index>-1){
          if (ele.module_code === 'CmnMster') {
            const commonModule = commonModuleCode.find((cm: Module) => permissions.some((p) => p.module_code === cm.module_code));
            if (commonModule) {
              ele.path = commonModule.path;
            }
          }
          result.push(ele)
        }
      }
    })
  return result;
}

export const PagePermission = (moduleCode: string,pageCode:string):boolean =>{
 const { permissions } = usePermissions();
 if (!Array.isArray(permissions)) return false;

 const moduleObject = permissions?permissions.find((x: Module) => x.module_code === moduleCode):-1; 
  return moduleObject?.pages.findIndex((x: Page) => x.page_code === pageCode) > -1;
}

export const PagePermissionRedirect = (moduleCode: string,pageCode:string,permissions:any):boolean =>{
  const permissionsJson = JSON.parse(permissions)
  //if (!Array.isArray(permissionsJson)) return false;
  const moduleObject = permissionsJson?permissionsJson.find((x: Module) => x.module_code === moduleCode):-1;
   return moduleObject?.pages.findIndex((x: Page) => x.page_code === pageCode) > -1;
 }

export const usePermission = (moduleCode: string,pageCode:string, privilege: string): boolean => {
   const { permissions } = usePermissions();  
   if (!Array.isArray(permissions)) return false;

   const moduleObject = permissions?permissions?.find((x: Module) => x.module_code === moduleCode):-1;
   const pageObject = moduleObject?.pages.find((x: Page) => x.page_code === pageCode);
   return moduleObject ? (pageObject?(pageObject.allowed_privileges.findIndex((x: string) => x === privilege)>-1) : false) : false;
 
 };
